<template>
    <div>
        <div class="banner">
        <span>{{$t("about.banner")}}</span>
        </div>
        <div class="section-wrap ">
            <tabnav :tab="tab"></tabnav>
            <div class="tab-content clearfix">
                <div class="fl c-left pc">
                    <img src="@/assets/images/about/c-logo.png" @click="routerSkip('/')" alt="logo" class="c-logo">
                    <div class="c-l-title active">{{ $t("culture.t1") }}</div>
                    <div class="c-l-title">{{ $t("culture.t2") }}</div>
                </div>
                <div class="fr c-right">
                  <div class="c-l-title active mobile">{{ $t("culture.t2") }}</div>
                    <div class="c-text" v-html='$t("culture.c1")'></div>
                    <div class="c-img-wrap rela c-wrap1">
                        <img class="c-img" src="@/assets/images/about/c-bg1.png"></img>
                        <div class="c-img-t c-img1 abso">
                            <div class="img-title">{{ $t("culture.st_1") }}</div>
                            <div class="img-content" v-html='$t("culture.sc_1")'></div>
                        </div>
                    </div>
                    <div class="c-img-wrap rela c-img-wrap-r tr">
                        <img class="c-img" src="@/assets/images/about/c-bg2.png"></img>
                        <div class="c-img-t c-img1 abso">
                            <div class="img-title">{{ $t("culture.st_2") }}</div>
                            <div class="img-content" v-html='$t("culture.sc_2")'></div>
                        </div>
                    </div>
                    <div class="c-img-wrap rela c-img-wrap-r c-wrap3 tr">
                        <img class="c-img pc" src="@/assets/images/about/c-bg3.png"></img>
                        <img class="c-img mobile" src="@/assets/images/about/c-m-bg3.png"></img>
                        <div class="c-img-t c-img1 abso">
                            <div class="img-title">{{ $t("culture.st_3") }}</div>
                            <div class="img-content" v-html='$t("culture.sc_3")'></div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
  
  <script>
  import tabnav from './components/tabnav'
export default {
  name: 'culture',
  components: {tabnav},
  data() {
    return {
        tab:3,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {},
  },
};
</script>
<style lang="stylus" scoped>
    @import "~@/assets/css/public.styl";
    .English {
      .c-wrap3{ line-height:1.3}
      .c-wrap1 .img-content{max-width:3.5rem}     
    } 
   
    .banner{height:280px;background :url("~@/assets/images/about/banner.jpg") no-repeat center/auto 100%;}
    .tab-content{margin-bottom: 1.45rem;background:#fff}
    .c-left
        padding-top: .6rem;width:3rem;padding-left:.5rem
        .c-logo
             margin: auto; width:2.54rem; height: .4rem;
    
    .c-l-title
             font-size:.24rem;color:#333;padding:.26rem 0 .64rem;rela()
             &.active{
                 color: $standardColor;
                 &::after{background:$standardColor;content:'';abso();left:0;bottom:.2rem;width:.3rem;height:.03rem;}
             }
    .c-right
      width: calc(100% - 3rem);padding:.6rem .5rem .4rem;
      .c-text
        color: #595757;font-size:.14rem;line-height:1.8;text-align:justify;
    .c-img-wrap
      margin-top:.3rem
      .c-img
        width: 100%;height:auto
      .c-img-t
        top:.9rem;left:.58rem;color:#fff
        .img-title
          font-size: .20rem;padding-bottom:.14rem;margin-bottom:.24rem;rela()
          &::after
            content: '';width:3.43rem;height:1px;background:rgba(238,243,249,.3);abso();bottom:0;left:0;
        .img-content
          font-size: .14rem
    .c-img-wrap-r
      .c-img-t
        left: auto;right:.58rem;
        .img-title::after
            right:0; left:auto;
    .c-wrap3
        .c-img-t
            top:1.23rem;width:6.6rem;
        .img-content
            text-align: justify
    
       
  @media screen and (max-width: 768px){ 
    .English {
      .c-img-wrap .c-img-t .img-content{line-height:1.35;}
      .c-wrap3 .c-img-t .img-content{padding-left:.32rem}
    } 
    .banner{height:3.7rem;background url("~@/assets/images/about/m-banner.jpg") no-repeat center/auto 100%;}
    .section-wrap {background:#fff;padding:0 0 .6rem} 
    .tab-content{margin-bottom:0;padding:0 .24rem}
    .c-right{width:100%;padding:.6rem 0 .4rem;
      .c-text{font-size:.24rem}
    }
    .c-img-wrap{
      margin-top:.56rem
      &.c-img-wrap-r .c-img-t{
        left 0 ; right:.48rem;
      }
      &.c-wrap3{
        .c-img-t{top:20%}
        .img-content{padding-left:.64rem}
      } 
      .c-img-t{
        top:25%;left:.48rem;
       
        .img-title{
          font-size:.28rem;padding-bottom:.1rem;margin-bottom:.1rem;
        }
        .img-content{
          font-size:.22rem;line-height:2;
        }
      }
    }
    .c-l-title{text-align:center;
      &.active{
        color:#333;padding-top:0;font-size:.32rem;
        &:after{
          right:0;margin auto;bottom:.4rem
        }
      }
    }
  }

</style>
<style>
 body{background: #f8f8f8}
</style>
  